export default __webpack_public_path__ + "static/media/SensorFootLeft.07ad78f4.svg";